// outline blue button

import React from 'react';

export default function OutlineBlueWithBlueTextBtn({ children, onClick }) {
    return (
        <button className="outline-blue-btn text-appblue" onClick={onClick}>{children}</button>
    )
}